var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoneyBackGuarantee32 = function SvgMoneyBackGuarantee32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.29 21.998c-7.827-3.63-6.136-13.238-6.136-13.238l6.136-2.762h.423l6.133 2.762s1.691 9.608-6.136 13.238h-.423.003Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13.252 22.605 15l3.895-3.5M16.348 10H4.21a2.24 2.24 0 0 0-1.563.63A2.12 2.12 0 0 0 2 12.15v12.7c0 .57.233 1.117.647 1.52.415.404.977.63 1.563.63h17.58a2.24 2.24 0 0 0 1.563-.63A2.12 2.12 0 0 0 24 24.85V22M2 16h15M6 23h6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMoneyBackGuarantee32;